import React from 'react';
import { Link } from 'react-router-dom';

function Privacy() {

  return (
    <div>
      <nav className="breadcrumb"><Link to="/">Home</Link></nav>

      <h2>Privacy Policy</h2>

      <p>This privacy policy explains how our store ("we", "our", or "the Store") collects, uses, and protects any information you provide when using this website. We are committed to protecting your privacy. If we ask you to provide certain information that can identify you, it will only be used in accordance with this policy.</p>

      <p>We may update this policy from time to time, so please check this page occasionally to ensure you are happy with any changes.</p>
{ /*
      <h3>What We Collect</h3>

      <ul>
      <li>Name</li>
      <li>Contact information including email address</li>
      <li>Demographic details such as postcode, preferences, and interests</li>
      <li>Other information relevant to customer service or promotions</li>
      </ul>

      <h3>What We Do with Your Information</h3>

      <ul>
      <li>Process and fulfill your orders</li>
      <li>Improve our products and services</li>
      <li>Send you promotional offers or updates (only if you’ve agreed)</li>
      <li>Contact you for customer feedback or surveys</li>
      </ul>
*/ }
      <h3>Security</h3>

      <p>We are committed to ensuring your data is secure. We have appropriate systems in place to protect the information we collect online.</p>

      <h3>How We Use Cookies</h3>

      <p>Cookies help us understand your preferences and improve your shopping experience. You can choose to accept or decline cookies through your browser settings. Declining may affect how you experience the website.</p>

      <h3>Links to Other Websites</h3>

      <p>Our website may contain links to other websites. Once you leave our site, we are not responsible for the protection of any information you provide on those external sites.</p>

      <h3>Affiliate Disclaimer</h3>

      <p>When you shop affiliate links at Amazon, AliExpress and other sites, we may receive a commission on qualifying purchases, at no additional cost to you.</p>

{ /*
      <h3>Controlling Your Personal Information</h3>

      <ul>
      <li>You can opt out of receiving promotional emails by following the unsubscribe link.</li>
      <li>You can request details of personal information we hold about you.</li>
      <li>You can ask us to correct or delete any inaccurate data.</li>
      </ul>

      <p>We do not sell or share your personal information with third parties unless required by law or with your permission.</p>

      <h3>Return Policy</h3>

      <p>We accept returns within 7 days of receiving your order. Items must be unused and in their original packaging. To start a return, please contact us with your order number and reason for the return.</p>
*/ }

    </div>
  );
}

export default Privacy;
